import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/karl/github.com/limbario/limbar/limbar-io/node_modules/next/dist/client/app-dir/link.js");
